import { render, staticRenderFns } from "./header-toolbar.vue?vue&type=template&id=24087894&"
import script from "./header-toolbar.vue?vue&type=script&lang=js&"
export * from "./header-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./header-toolbar.vue?vue&type=style&index=0&id=24087894&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports